module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page b2b",
    attrs: {
      "id": "start"
    }
  }, [(0 && !_vm.$root.partnerId) ? _c('youtube', {
    staticClass: "youtubeWrap",
    attrs: {
      "id": "youtubeOpqBackground",
      "video-id": _vm.videoId,
      "player-vars": _vm.videoVars
    },
    on: {
      "playing": _vm.onVideoPlaying,
      "ready": _vm.onPlayerReady
    }
  }) : _vm._e(), _vm._v(" "), (_vm.startContent) ? _c('v-runtime-template', {
    attrs: {
      "template": _vm.startContent
    }
  }) : _c('div', {
    staticClass: "startContent"
  }, [_c('h2', {
    staticClass: "entry-title"
  }, [_vm._v("Få “hurtig-takst” nå")]), _vm._v(" "), _c('start-actions'), _vm._v(" "), (_vm.$root.isGuestPage()) ? _c('p', [_vm._v("Utbedre skaden på bilen og få en sakkyndig vurdering.")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc787e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Start.vue
// module id = 108
// module chunks = 0